/**
 * Get the display text for a watch type
 * @param {Object} watch - The watch object
 * @param {Function} t - Translation function
 * @returns {string} - The formatted display text
 */
export const getWatchTypeDisplay = (watch, t) => {
  const { type } = watch;
  
  if (type === 'PSA_SINGLE_CARD' && watch.psaGrades?.length > 0) {
    return watch.psaGrades.map(grade => {
      // Transform PSA_10 to PSA10 for display
      return grade.replace('PSA_', t('favorite.watch_types.psa_grade'));
    }).join(', ');
  } else if (type === 'CARD_BOX' && watch.bundledQuantities?.length > 0) {
    return watch.bundledQuantities.map(quantity => {
      return `${quantity} ${watch.watchable?.boxType === 'PACK' ? t('box.pack') : t('favorite.watch_types.box_unit')}`;
    }).join(', ');
  } else if (type === 'NON_PSA_SINGLE_CARD' && watch.watchable?.condition) {
    const conditionKey = watch.watchable.condition.toLowerCase();
    return t(`sell.product_info.conditions.${conditionKey}`);
  }
  
  return '';
}; 